// extracted by mini-css-extract-plugin
module.exports = {"headerSection":"episode-module--headerSection--3JPXl","playPauseButton":"episode-module--playPauseButton--22FyX"};